export const config = {
  baseURL: "https://topmanbe.pcpexpress.com/api",
  // baseURL: "http://10.3.3.202:8088/api",
  // baseURL: "http://10.3.3.242:8088/api",
  // baseURL: "http://127.0.0.1:8000/api",
};
